import type { ItemWithSlug, SelectOptionItem } from "./select.type";
import type { NamedModel } from "@/entities/named-model";
import type { FormFieldPath } from "@/modules/form";
import type { FormInstance } from "antd";

import { isValidObject } from "@/utilities/object";

export const convertItemWithSlugToOption = (
  entry?: ItemWithSlug
): SelectOptionItem => {
  return {
    value: entry?.slug || "",
    label: entry?.name || entry?.slug || "",
  };
};

export const getSelectMultipleValues = <
  FormValues = unknown,
  SelectValue = unknown,
>(
  form: FormInstance<FormValues>,
  fieldName: FormFieldPath<FormValues>,
  defaultValue?: SelectValue[]
) => {
  const chosenOptions: SelectOptionItem<SelectValue>[] | undefined =
    form.getFieldValue(fieldName);

  return chosenOptions?.map((option) => option.value) || defaultValue;
};

export const getSelectSingleValue = <
  FormValues = unknown,
  SelectValue = unknown,
>(
  form: FormInstance<FormValues>,
  fieldName: FormFieldPath<FormValues>,
  defaultValue?: SelectValue
) => {
  const chosenOption: SelectOptionItem<SelectValue> | undefined =
    form.getFieldValue(fieldName);

  return chosenOption?.value || defaultValue;
};

export const filterSelectValidOptions = <Value = unknown>(
  options: SelectOptionItem<Value>[]
) => {
  return (options ?? []).filter((option) => isValidObject(option));
};

export const getModelSelectOptionValue = (model?: NamedModel) => {
  if (!model) return undefined;

  return {
    value: model.id,
    label: model.name,
    key: model.id,
  };
};
